import React, {memo, useCallback, useEffect, useRef, useState} from "react";
import { useTranslation } from 'react-i18next';
import {Rate} from "antd";

// Components
import CircleIcon from "sharedComponents/CircleIcon";
import TextWithLinks from "sharedComponents/TextWithLinks";
import {overallPerformanceRating} from "../config";

// Hooks
import useDropoutSurveyField from "Hooks/useDropoutSurveyField";

// Utils
import validateExplanationField from "utils/validateExplanationField";
import {findDOMNode} from "react-dom";


const ENPS = ({fieldData, getAnswer, handleChangeSurveyCompletionStatus, mandatoryRefs, disabled = false}) => {
    const explanationRef = useRef();
    const enpsRef = useRef();
    const [showError, SetShowError] = useState('');
    const [rateVal, SetRateVal] = useState(null);
    const [showExplanation, SetShowExplanation] = useState(false);
    const { t } = useTranslation();
    const isLast = fieldData.label.includes(overallPerformanceRating);

    useDropoutSurveyField(rateVal, '', handleChangeSurveyCompletionStatus);

    const handleChangeRate = useCallback((value) => {
        SetRateVal(+value === 0 ? null : value);
        SetShowExplanation(!!fieldData.explanation && value !== 0);

        if (fieldData.explanation && value !== 0) {
            const explanationValidation = validateExplanationField(explanationRef.current?.value, isLast);
            SetShowError(explanationValidation);
        }

        if (!value) {
            const fieldNode = findDOMNode(enpsRef.current);
            if (fieldData.mandatory) {
                if (Array.isArray(mandatoryRefs) && !mandatoryRefs.includes(fieldNode)) {
                    mandatoryRefs.unshift(fieldNode);
                }
            }
        }
    }, [showError, fieldData]);

    const handleChangeExplanation = (e) => {
        SetShowError(validateExplanationField(e.target.value, isLast));
    };

    useEffect(() => {
        if (fieldData?.answers?.answer) {
            SetShowExplanation(!!fieldData?.answers?.explanation);
            explanationRef.current.value = fieldData?.answers?.explanation;
            SetRateVal(+fieldData?.answers?.answer === 0 ? 1 : fieldData?.answers?.answer);
        }
    }, []);

    useEffect(() => {
        if (getAnswer.constructor !== Boolean) {
            getAnswer(prevState => ({
                ...prevState,
                [fieldData.id] : {answer: (rateVal || (rateVal === 0)) ? rateVal - 1 : '', explanation: explanationRef.current.value}
            }));

            const explanationValidation = validateExplanationField(explanationRef.current?.value, isLast);
            explanationValidation && SetShowError(explanationValidation);

            (fieldData.mandatory && !rateVal) ? SetShowError('Required') : SetShowError('');
        }
    }, [getAnswer, rateVal, fieldData]);

    useEffect(() => {
        const fieldNode = findDOMNode(enpsRef.current);
        if (fieldData.mandatory) {
            if (Array.isArray(mandatoryRefs) && !mandatoryRefs.includes(fieldNode)) {
                mandatoryRefs.push(fieldNode);
            }
        }
    }, [fieldData]);

    return (<div
        ref={enpsRef}
        className={`single_sect ${showError ? "invalid" : ""} ${isLast ? 'single_sect_last' : ''}`}
    >
        <h3 className="single_sect_primary_text">
            {fieldData.label}
            {!!fieldData.mandatory && <sup className="enps_sup">*</sup>}
        </h3>
        <TextWithLinks className="single_sect_secondary_text">
            {fieldData.description}
        </TextWithLinks>
        <div className="rate_with_explanation">
            <div className="enps_satisfaction_rate_container">
                <div className="enps_likely_explanation">
                    <span>{t("Not at all likely")}</span>
                    <span>{t("Very likely")}</span>
                </div>
                <Rate
                    defaultValue={(fieldData?.answers?.answer !== false) && +fieldData?.answers?.answer + 1}
                    count={11}
                    className={`satisfaction_rate_sect satisfaction_rate_sect_ENPS`}
                    onChange={handleChangeRate}
                    disabled={disabled}
                    character={(({index}) => <div className="enps_satisfaction_rate_numbers">
                        <p className="enps_rate_numbers">
                            {index}
                        </p>
                        <CircleIcon />
                    </div>)}
                />
            </div>

            <div
                className={`input_field hidden_input_field ${showExplanation ? "show" : "hide"}`}
            >
                <input
                    ref={explanationRef}
                    onChange={handleChangeExplanation}
                    type="text"
                    placeholder={t("Explain your choice (optional)...")}
                    disabled={disabled}
                />
            </div>
        </div>
        <div className="error_sect">
            {showError}
        </div>
    </div>);
};

export default memo(ENPS);